import {
    ARRIVES_ROUTE,
    CART_ROUTE,
    CHECKOUT_ROUTE,
    CONTACT_ROUTE,
    CUSTOMER_PROFILE_ROUTE,
    MAIN_ROUTE,
    NOUVEAUTES_ROUTE,
    PRODUCT_ROUTE,
    STORE_NAME,
    TERMS_ROUTE
} from "@/utils/constants.js";
import { CUSTOMER_PROFILE_DEFAULT_SECTION, CUSTOMER_PROFILE_MENU } from "@/utils/profileMenus.js";

const CUSTOMER_SECTION_TITLES = Object.fromEntries(
    CUSTOMER_PROFILE_MENU.map(({ id, label }) => [id, label])
);

/**
 * @returns {string|null} Tab title, or {@code null} when the page sets its own (product / order detail).
 */
export function resolveStoreDocumentTitle(pathname, searchParams = new URLSearchParams()) {
    if (pathname === MAIN_ROUTE || pathname === "") {
        return STORE_NAME;
    }
    if (pathname.startsWith(`${PRODUCT_ROUTE}/`)) {
        return null;
    }
    if (pathname.startsWith("/orders/")) {
        return null;
    }
    if (pathname === NOUVEAUTES_ROUTE) {
        return `Nouveaux articles — ${STORE_NAME}`;
    }
    if (pathname === ARRIVES_ROUTE) {
        return `Articles restockés — ${STORE_NAME}`;
    }
    if (pathname === CONTACT_ROUTE) {
        return `Contact — ${STORE_NAME}`;
    }
    if (pathname === TERMS_ROUTE) {
        return `Conditions générales — ${STORE_NAME}`;
    }
    if (pathname === CART_ROUTE) {
        return `Mon panier — ${STORE_NAME}`;
    }
    if (pathname === CHECKOUT_ROUTE) {
        return `Commander — ${STORE_NAME}`;
    }
    if (pathname === CUSTOMER_PROFILE_ROUTE) {
        const section = searchParams.get("section") || CUSTOMER_PROFILE_DEFAULT_SECTION;
        const label = CUSTOMER_SECTION_TITLES[section] || "Mon espace";
        return `${label} — ${STORE_NAME}`;
    }
    return STORE_NAME;
}
